'use client';

import React from 'react';

import ArrowUp from './lib/ArrowUp';
import Close from './lib/Close';
import Download from './lib/Download';
import File from './lib/File';
import Video from './lib/Video';

import styles from './_styles/Icon.module.scss';


const Icon = (props) => {

	const {
		value,
		iconClass = '',
		iconWrapperClass = '',
		iconLabel,
		iconLabelClass = '',
		ellipsisLabel = false,
		bottomClass = '',
		onClick = () => {},
	} = props;

	const getIconValue = () => {
		const iconMap = {
			arrowUp: <ArrowUp />,
			close: <Close />,
			download: <Download />, 
			file: <File />, 
			video: <Video />, 
		};
		return iconMap[value] || null;
	};

	return (
		<div className={`${styles.Icon} ${iconClass}`} onClick={onClick}>
			<div className={`${styles.svgWrapper} ${iconWrapperClass}`}>
				{getIconValue()}
			</div>
			{iconLabel && (
				<div className={`${styles.label} ${ellipsisLabel ? 'EllipsisElement' : ''} ${iconLabelClass}`}>
					{iconLabel}
				</div>
			)}
			<div className={`${bottomClass}`} />
		</div>
	);
};

export default Icon;
